import React, { Component } from "react";
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import {callGET, callPOST } from '../../../Utils/ApiUtil';
import Select from "react-select";
import * as actions from '../../../store/actions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import { checkIsSystemUser, getUserInfo, getUserWindows } from "../../../Utils/UserFunctions";
import * as ShipConstants from '../../../Global/Constants';
import { isSet, parameterizedURLAccessToken } from '../../../Utils/CommonFunctions';
class ExportContainerV2 extends Component {

  state = {
    exportFormFields: {
      base: true,
      api: false,
      api_ids: [],
      automation: false,
      automation_ids: [],
      step: false,
      step_ids: [],
      calculation: false,
      calculation_ids: [],
      window: false,
      window_ids: [],
      pdf_template: false,
      pdf_template_ids: [],
      excel_template: false,
      excel_template_ids: [],
      email_template: false,
      email_template_ids: [],
      email_data_config: false,
      email_data_config_ids: [],
      user_id: "",
      export_directory_id: "",
      organization_id: ""
    },
    organization: {
      title: "Organization",
      field: "select",
      required: false,
      placeHolder: "",
      classname: 'form-control input-full',
      value: '',
      error: '',
      disabled: false,
      options: []
    },
    formFieldOptions: {
      api: [],
      window: [],
      calculation: [],
      step: [],
      window: [],
      automation: [],
      excel: [],
      email: [],
      email_data_config: [],
      pdf: []
    },


  }

  componentWillMount = () => {
    if (this.state.exportFormFields.organization_id === "") {
      const user = getUserInfo();
      if (user !== null && user.data.org_id !== undefined) {
        let updatedState = this.state.exportFormFields;
        updatedState.organization_id = user.data.org_id;
        this.setState({
          exportFormFields: updatedState
        })
      }
    }
    this.organizationList();
    this.windowList();
  }
  componentDidUpdate = (prev) => {

  }

  organizationList = () => {
    callGET("organizations/organization-list/?orderBy=organization_name&direction=ASC&page=0&size=1000000")
      .then(response => {
        const responseData = response.data.data;
        if (response.data.code === ShipConstants.API_STATUS_SUCCESS) {
          const updateState = { ...this.state };
          updateState['organization'].options = responseData.organization_list.content;
          this.setState(updateState);
        }
      }, (error) => {
        console.log(error);
      });
  }

  onChangeHandler = (event) => {
    const { name, value } = event.target;
    const updateState = { ...this.state };
    let defaultExportFormFields = {
      base: true,
      api: false,
      api_ids: [],
      automation: false,
      automation_ids: [],
      step: false,
      step_ids: [],
      calculation: false,
      calculation_ids: [],
      window: false,
      window_ids: [],
      pdf_template: false,
      pdf_template_ids: [],
      excel_template: false,
      excel_template_ids: [],
      email_template: false,
      email_template_ids: [],
      user_id: "",
      export_directory_id: "",
      organization_id: ""
    }
    let defaultFormFieldOptions = {
      api: [],
      window: [],
      calculation: [],
      step: [],
      window: [],
      automation: [],
      excel: [],
      email: [],
      pdf: []
    }

    let checkBoxFields = ["api", "step", "automation", "window", "base", "email_data_config", "calculation", "pdf_template", "email_template", "excel_template"];
    // let listSelections = ['api_ids', 'calculation_ids', 'step_ids', "automation_ids","email_data_config_ids", "email_template_ids", "pdf_template_ids", "excel_template_ids", "window_ids"]
    let checkBoxRelation = {"api":"api_ids","step":"step_ids","automation":"automation_ids","window":"window_ids","email_data_config":"email_data_config_ids","calculation":"calculation_ids","pdf_template":"pdf_template_ids","email_template":"email_template_ids","excel_template":"excel_template_ids"};
    if (name === "organization_id") {
      updateState.exportFormFields = defaultExportFormFields;
      updateState.formFieldOptions = defaultFormFieldOptions
    }
    if (checkBoxFields.indexOf(name) !== -1) {
      updateState.exportFormFields[name] = event.target.checked;
      if(checkBoxRelation[name]!==undefined){
        updateState.exportFormFields[checkBoxRelation[name]]=[]
      }
      this.loadOptions(name, event.target.checked);
    } else {
      updateState.exportFormFields[name] = value;
    }
    this.setState(updateState);
  }


  loadOptions = (name, isChecked) => {
    if (isChecked) {
      if (name === "api") {
        this.apiListApi();
      } else if (name == "calculation") {
        this.calculationListApi();
      } else if (name === "automation") {
        this.automationListApi();
      } else if (name === "step") {
        this.stepsListApi();
      } else if (name === "window") {
        this.windowList();
      } else if (name === "pdf_template") {
        this.pdfListApi();
      } else if (name === "excel_template") {
        this.excelList();
      } else if (name === "email_template") {
        this.emailTemplateListApi();
      } else if (name === "email_data_config") {
        this.emailToDataList();
      }
    }
  }
  windowList = () => {
    const userWindows = getUserWindows();
    let windowList = [];
    if (userWindows !== undefined && userWindows !== null) {
      userWindows.map((item, i) => {
        windowList.push({
          value: item.window_id,
          name: item.window_name,
          label: item.window_name,
          id: item.window_id
        })
      })
      let updateState = this.state.formFieldOptions;
      updateState.window = windowList;
      this.setState({
        formFieldOptions: updateState
      })
    }

  }

  stepsListApi = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 100;//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    let updateState = formFieldOptions;
    let apiList = [{ value: '', name: 'All', label: 'All' }];
    this.props.Loader(true);
    const body = {
      'organization_id': exportFormFields.organization_id,
      'user_id': "",
    };
    const header = { 'Content-Type': 'application/json' };
    const queryString = '?query=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
    callPOST("steps/paginated-search" + queryString, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200 && response.data !== undefined && response.data !== null) {
            apiList = [];
            response.data.content.map((item) => {
              apiList.push({
                value: item.id,
                name: item.name,
                label: item.name
              })
            });
            updateState.step = apiList;
            this.setState({ formFieldOptions: updateState });
          } else {
            updateState.step = apiList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          updateState.step = apiList;
          this.setState({ formFieldOptions: updateState });
        }
        this.props.Loader(false);
      }, (error) => {
        this.props.Loader(false);
        if (updateState.step !== undefined) {
          updateState.step = apiList;
        }
        // console.log(updateState);
        this.setState({ formFieldOptions: updateState });
        this.props.failMessage("steps/search : Something went wrong..");
      })
  }
  apiListApi = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 999999;//pagination.perPage; 
    const direction = '';//pagination.direction;  
    const search = '';//pagination.search;
    let updateState = formFieldOptions;
    const body = {
      'organization_id': exportFormFields.organization_id,
      'is_active': true,
      'user_id': "",
      'window_id': ""
    };
    const header = { 'Content-Type': 'application/json' };
    let apiList = [{ value: '', name: 'All', label: 'All' }];
    const queryString = '?query=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
    this.props.Loader(true);
    callPOST("api-client/paginated-search" + queryString, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200 && response.data !== undefined && response.data !== null) {
            apiList = []
            response.data.content.map((item) => {
              apiList.push({
                value: item.id,
                name: item.collection_name,
                label: item.collection_name,
                window_id: item.window_id
              })
            });

            updateState.api = apiList;
            this.setState({ formFieldOptions: updateState });
          } else {
            updateState.api = apiList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          updateState.api = apiList;
          this.setState({ formFieldOptions: updateState });
        }
        this.props.Loader(false);
      }, (error) => {
        this.props.Loader(false);
        console.log("error", error)
      })
  }

  automationListApi = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 999999;//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    let updateState = formFieldOptions;
    let automationList = [{ value: '', name: 'All', label: 'All' }];
    const body = {
      'organization_id': exportFormFields.organization_id,
      'user_id': "",
    };
    const header = { 'Content-Type': 'application/json' };
    this.props.Loader(true);
    const queryString = '?query=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
    callPOST("automations-process/paginated-search" + queryString, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200 && response.data !== undefined && response.data !== null) {
            automationList = [];                
            response.data.content.map((item) => {
              automationList.push({
                value: item.id,
                name: item.name,
                label: item.name
              })
            });

            updateState.automation = automationList;
            this.setState({ formFieldOptions: updateState });
          } else {
            updateState.automation = automationList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          updateState.automation = automationList;
          this.setState({ formFieldOptions: updateState });
        }
        this.props.Loader(false);
      }, (error) => {
        this.props.Loader(false);
        if (updateState.automation !== undefined) {
          updateState.automation = automationList;
        }
        console.log(error);
        this.setState({ formFieldOptions: updateState });
        this.props.failMessage("automations-process/search : Something went wrong..");
      })
  }


  calculationListApi = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 999999;//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    const body = {
      'organization_id': exportFormFields.organization_id,
      'user_id': "",
    };
    const header = { 'Content-Type': 'application/json' };
    let updateState = formFieldOptions;
    let calculationList = [{ value: '', name: 'All', label: 'All' }];
    const queryString = '?query=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
    this.props.Loader(true);
    callPOST("rates/paginated-search" + queryString, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200 && response.data !== undefined && response.data !== null) {
            calculationList = [];
            response.data.content.map((item) => {
              calculationList.push({
                id: item.id,
                value: item.id,
                text: item.name,
                label: item.name,
              })
            });
            updateState.calculation = calculationList;
            this.setState({ formFieldOptions: updateState });
          } else {
            updateState.calculation = calculationList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          updateState.calculation = calculationList;
          this.setState({ formFieldOptions: updateState });
        }
        this.props.Loader(false);
      }, (error) => {
        console.log("error", error)
        this.props.Loader(false);
        this.props.failMessage("calculation/search : Something went wrong..");
      })
  }
  excelList = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const body = {
      "active": true,
      "admin": true,
      "id": "",
      "organization_id": exportFormFields.organization_id,
      "user_id": "",
      "variable_mapping": "",
      "window_id": ""
    }
    const header = { 'Content-Type': 'application/json' };
    const queryString = '?search=&page=0&orderBy=&size=999999&direction=ASC';
    let updateState = formFieldOptions;
    let varList = [{ value: '', name: 'All', label: 'All' }];
    this.props.Loader(true);
    callPOST("excel/templates/paginated-search/" + queryString, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200) {
            varList = [];
            response.data.content.map((arr, i) => {
              const value = {
                "id": arr.id,
                "label": arr.name + " [" + arr.window_name + "]",
                "name": arr.name,
                "value": arr.id,
              }
              varList.push(value);
            })
            updateState['excel'] = varList;
            this.setState({ formFieldOptions: updateState });
          }
        }
        this.props.Loader(false);
      }, (error) => {
        this.props.Loader(false);
        this.props.failMessage("Something went wrong..");
      })
  }

  pdfListApi = () => {
    const { formFieldOptions, exportFormFields } = this.state;
    const body = {
      "active": true,
      "organization_id": exportFormFields.organization_id,
      "user_id": ""
    }
    let updateState = formFieldOptions;
    const header = { 'Content-Type': 'application/json' };
    let pdfList = [{ value: '', name: 'All', label: 'All' }];
    this.props.Loader(true);
    callPOST("PDF/templates/paginated-search?size=" + 99999, body, header)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200 && response.data !== undefined && response.data !== null) {
            pdfList = [];
            response.data.content.map((item) => {
              pdfList.push({
                id: item.id,
                value: item.id,
                text: item.design_name,
                label: item.design_name + "[" + item.window_name + "]",
              })
            });
            updateState.pdf = [...updateState.pdf, ...pdfList];
            this.setState({ formFieldOptions: updateState });
          } else {
            updateState.pdf = pdfList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          updateState['pdf'] = pdfList;
          this.setState({ formFieldOptions: updateState });
        }
        this.props.Loader(false);
      }, (err) => {
        console.log("error", err);
        this.props.Loader(false);
      })
  }

  // call method htmlFor template list
  emailTemplateListApi = (tagId = '') => {
    const { formFieldOptions, exportFormFields } = this.state;
    const url = "email/template/search";
    let updateState = formFieldOptions;
    let varList = [{ value: '', name: 'All', label: 'All' }];
    this.props.Loader(true);
    callGET(url + "?organizationId=" + exportFormFields.organization_id)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200) {
            if (response.data !== null && response.data !== undefined) {
              varList = []
              response.data.content.map((item, index) => {
                const value = {
                  "id": item.id,
                  "label": item.name + "[" + item.window_name + "]",
                  "name": item.name,
                  "value": item.id,
                }
                varList.push(value);
              })
            }
            updateState['email'] = varList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          this.props.failMessage('Something went wrong!!!');
        }
        this.props.Loader(false);
      }, (error) => {
        this.props.Loader(false);
        this.props.failMessage('Something went wrong!!!');
        console.log(error);
      })
  }

  emailToDataList = () => {
    const { formFieldOptions } = this.state
    const page = 0;//pagination.page; 
    const orderBy = '';//pagination.orderBy; 
    const perPage = 999999;//pagination.perPage; 
    const direction = '';//pagination.direction; 
    const search = '';//pagination.search;
    const url = "email/data-config/search";
    const queryString = '?search=' + search + '&page=' + page + '&orderBy=' + orderBy + '&size=' + perPage + '&direction=' + direction;
    let updateState = formFieldOptions;
    let emailDataList = [{ value: '', name: 'All', label: 'All' }];
    this.props.Loader(true);
    callGET(url + queryString)
      .then(res => {
        if (res.status === 200) {
          const response = res.data;
          if (response.code === 200) {
            if (response.data !== null && response.data !== undefined) {
              emailDataList = []
              response.data.content.map((item, index) => {
                const value = {
                  "id": item.id,
                  "label": item.name + "[" + item.window_name + "]",
                  "name": item.name,
                  "value": item.id,
                }
                emailDataList.push(value);
              })
            }
            updateState['email_data_config'] = emailDataList;
            this.setState({ formFieldOptions: updateState });
          }
        } else {
          this.props.failMessage('Something went wrong!!!');
        }
        this.props.Loader(false);

      }, (error) => {
        console.log("error", error);
        this.props.Loader(false);
      })
  }




  download = (arrayBuffer, type) => {
    var blob = new Blob([arrayBuffer], { type: type });
    var url = URL.createObjectURL(blob);
    window.open(url);
  }

  getFileIds = (res) => {
    let fileIds = '';
    res.map((arr, i) => {
      fileIds += arr.id + ',';
      // return true;
    })
    return fileIds;
  }

  getStringValuesFromList = (list, fieldName) => {
    let values = [];
    if (list !== undefined && list !== null) {
      isSet(list, []).map((item) => {
        values.push(item[fieldName]);
      });
    }
    return values;
  }

  NewExportHandler = () => {
    const { exportFormFields } = this.state;
    let postData = this.state.exportFormFields;
    let stepIds = [];
    let automationIds = [];
    let calculationIds = [];
    let apiIds = [];
    let pdfTemplateIds = [];
    let emailTemplateIds = [];
    let excelTemplateIds = [];
    let windowList = [];
    if (exportFormFields.api_ids !== null && exportFormFields.api_ids.length > 0) {
      apiIds = this.getStringValuesFromList(exportFormFields.api_ids, "value");
    }
    if (exportFormFields.window_ids !== null && exportFormFields.window_ids.length > 0) {
      windowList = this.getStringValuesFromList(exportFormFields.window_ids, "value");
    }
    if (exportFormFields.step_ids !== null && exportFormFields.step_ids.length > 0) {
      stepIds = this.getStringValuesFromList(exportFormFields.step_ids, "value");
    }
    if (exportFormFields.automation_ids !== null && exportFormFields.automation_ids.length > 0) {
      automationIds = this.getStringValuesFromList(exportFormFields.automation_ids, "value");
    }
    if (exportFormFields.calculation_ids !== null && exportFormFields.calculation_ids.length > 0) {
      calculationIds = this.getStringValuesFromList(exportFormFields.calculation_ids, "value");
    }
    if (exportFormFields.pdf_template_ids !== null && exportFormFields.pdf_template_ids.length > 0) {
      pdfTemplateIds = this.getStringValuesFromList(exportFormFields.pdf_template_ids, "value");
    }
    if (exportFormFields.excel_template_ids !== null && exportFormFields.excel_template_ids.length > 0) {
      excelTemplateIds = this.getStringValuesFromList(exportFormFields.excel_template_ids, "value");
    }
    if (exportFormFields.email_template_ids !== null && exportFormFields.email_template_ids.length > 0) {
      emailTemplateIds = this.getStringValuesFromList(exportFormFields.email_template_ids, "value");
    }


    postData = { ...postData, api_ids: apiIds, step_ids: stepIds, automation_ids: automationIds, calculation_ids: calculationIds, window_ids: windowList, pdf_template_ids: pdfTemplateIds, excel_template_ids: excelTemplateIds, email_template_ids: emailTemplateIds };
    console.log("PostData", postData)
    this.props.Loader(true);
    const header = { 'Content-Type': 'application/json' };
    callPOST("metadata/export-as-xml", postData, header)
      .then(response => {
        this.props.Loader(false);
        if (response.status === 200) {
          const responseData = response.data;
          if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            this.props.succMessage(responseData.message);
            let zipFileId = responseData.data.zip_file_id;
            if (zipFileId !== undefined && zipFileId !== "") {
              document.location.href = parameterizedURLAccessToken("files/download?fileId=" + zipFileId);
            }
          } else {
            this.props.failMessage(responseData.message);
          }
        }

      })
      .catch(err => {
        this.props.Loader(false);
        this.props.failMessage("Error occured");
        console.log(err);
      })
  }

  render() {
    const params = this.props.match.params;
    const { formFieldOptions, exportFormFields } = this.state

    const breadCrumbs = {
      backHistory: [{
        href: "/settings",
        name: "Settings"
      }],
      pageTitle: "Import/Export",
      buttonList: [
        {
          name: "Export",
          type: "",
          clickHandler: this.NewExportHandler,
          attributes: {
            className: "btn primary_bg",
          },
        },
      ],
    }

    //HEADER TABS
    const headerTabs = [{
      name: "Import",
      attributes: {
        "aria-selected": false,
        className: "nav-link"
      },
      href: "/import-export/import",
    },
    {
      name: "Export",
      attributes: {
        "aria-selected": false,
        className: "nav-link "
      },
      href: "/import-export/export",
    }]
    return (

      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <HeaderTabs
          attributes={{
            className: "nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
          }}
          headerTabsList={headerTabs} />
        <div className="viewport">
          <div className="view view-xl">

            <div className="outerPort">
              <div className="table_Box dataTables_wrapper">
              {
                    (checkIsSystemUser()) ?
                <div className="table_Header">
                  <div className="d-flex align-items-center justify-content-center" style={{gap:'20px'}}>

                  
                      <div className="form-group mb-0 w-100">
                        <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4"> Choose Organisation</label>
                        <div className="col-lg-9 col-md-9 col-sm-8">
                          <div className="form-group">
                            <div className="input-group mb-3">
                              <select className="form-control" name="organization_id" onChange={e => this.onChangeHandler(e)}>
                                <option value=""></option>
                                {
                                  this.state.organization.options.map((arr, i) => {
                                    let organizationName = arr.organization_name;
                                      if(organizationName.length>80){
                                        organizationName = organizationName.substring(0,30)+"...";
                                      }
                                    return <option key={i} value={arr.id}>{organizationName}</option>
                                  })
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    

                  </div>
                </div>
                  : null
                }
                <div className="table_Body ">
                  <div className="row justify-content-md-center">
                    <div className="col-md-4">
                      <div className="card mb-0">
                        <div className="card-header">
                          <div className="card-title">  Import DataSet Includes </div>
                        </div>
                        <div className="card-body"  style={{height: "calc(100vh - 276px)",overflow:"auto"}}>
                          <div className="form-group">
                            

                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group row border-bottom">
                                    <label class="col-md-10">  Base Data <br />[ user, profile, layout, organization and others information] </label>
                                    <div class="col-md-2">
                                      <div class="material-switch p-2">
                                      <input id="base_include"
                                        name="base"
                                        type="checkbox"
                                        checked={exportFormFields.base}
                                        onChange={this.onChangeHandler}
                                      />
                                      <label htmlFor="base_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10"> Windows Data </label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="window_include"
                                          name="window"
                                          type="checkbox"
                                          checked={exportFormFields.window}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="window_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.window) ? <div className="col-12">
                                        <Select
                                          isMulti={true}
                                          options={formFieldOptions.window}
                                          value={exportFormFields.window_ids}
                                          onChange={(list) => {
                                            let event = {
                                              target: {
                                                name: "window_ids",
                                                value: list
                                              }
                                            }
                                            this.onChangeHandler(event)
                                          }}
                                          name="window_ids"
                                        />
                                      </div> : null
                                    }

                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Api Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="api_include"
                                          name="api"
                                          type="checkbox"
                                          checked={exportFormFields.api}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="api_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.api) ? <div className="col-12">
                                        <Select
                                          isMulti={true}
                                          options={formFieldOptions.api}
                                          value={exportFormFields.api_ids}
                                          onChange={(list) => {
                                            let event = {
                                              target: {
                                                name: "api_ids",
                                                value: list
                                              }
                                            }
                                            this.onChangeHandler(event)
                                          }}
                                          name="api_ids"
                                        />
                                      </div> : null
                                    }

                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Steps Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="step_include"
                                          name="step"
                                          type="checkbox"
                                          checked={exportFormFields.step}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="step_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.step) ? <div className="col-12">
                                        {/* <Inputs  fieldName="api_name" formData={JSON.stringify(apiList)} changed={(e)=>console.log("api picklist")}/>  */}
                                        <Select
                                          isMulti={true}
                                          options={formFieldOptions.step}
                                          value={exportFormFields.step_ids}
                                          onChange={(list) => {
                                            let event = {
                                              target: {
                                                name: "step_ids",
                                                value: list
                                              }
                                            }
                                            this.onChangeHandler(event)
                                          }}
                                          name="api_ids"
                                        />
                                      </div> : null
                                    }

                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Calculation Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="calculation_include"
                                          name="calculation"
                                          type="checkbox"
                                          checked={exportFormFields.calculation}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="calculation_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {(exportFormFields.calculation) ?
                                      <div className="col-12">
                                        <Select
                                          isMulti={true}
                                          options={formFieldOptions.calculation}
                                          value={exportFormFields.calculation_ids}
                                          onChange={(list) => {
                                            let event = {
                                              target: {
                                                name: "calculation_ids",
                                                value: list
                                              }
                                            }
                                            this.onChangeHandler(event)
                                          }}
                                          name="api_ids"
                                        />
                                      </div> : null
                                    }
                                  </div>
                                </div>
                              </div>

                              <div className="form-group row border-bottom">
                                <label className="col-md-10">Automation Data</label>
                                <div className="col-md-2">
                                  <div className="material-switch p-2">
                                    <input id="automation_include"
                                      name="automation"
                                      type="checkbox"
                                      checked={exportFormFields.automation}
                                      onChange={this.onChangeHandler}
                                    />
                                    <label htmlFor="automation_include" className="secondary_bg"></label>
                                  </div>
                                </div>
                                {(exportFormFields.automation) ?
                                  <div className="col-12">
                                    <Select
                                      isMulti={true}
                                      options={formFieldOptions.automation}
                                      value={exportFormFields.automation_ids}
                                      onChange={(list) => {
                                        let event = {
                                          target: {
                                            name: "automation_ids",
                                            value: list
                                          }
                                        }
                                        this.onChangeHandler(event)
                                      }}
                                      name="api_ids"
                                    />
                                  </div> : null
                                }
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">PDF Template Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="pdf_include"
                                          name="pdf_template"
                                          type="checkbox"
                                          checked={exportFormFields.pdf_template}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="pdf_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.pdf_template) ?
                                        <div className="col-12">
                                          <Select
                                            isMulti={true}
                                            options={formFieldOptions.pdf}
                                            value={exportFormFields.pdf_template_ids}
                                            onChange={(list) => {
                                              let event = {
                                                target: {
                                                  name: "pdf_template_ids",
                                                  value: list
                                                }
                                              }
                                              this.onChangeHandler(event)
                                            }}
                                            name="pdf_template_ids"
                                          />
                                        </div> : null

                                    }

                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Excel Template Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="excel_include"
                                          name="excel_template"
                                          type="checkbox"
                                          checked={exportFormFields.excel_template}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="excel_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.excel_template) ?
                                        <div className="col-12">
                                          <Select
                                            isMulti={true}
                                            options={formFieldOptions.excel}
                                            value={exportFormFields.excel_template_ids}
                                            onChange={(list) => {
                                              let event = {
                                                target: {
                                                  name: "excel_template_ids",
                                                  value: list
                                                }
                                              }
                                              this.onChangeHandler(event)
                                            }}
                                            name="excel_template_ids"
                                          />
                                        </div> : null
                                    }

                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Email Template Data</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="email_include"
                                          name="email_template"
                                          type="checkbox"
                                          checked={exportFormFields.email_template}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="email_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.email_template) ?
                                        <div className="col-12">
                                          <Select
                                            isMulti={true}
                                            options={formFieldOptions.email}
                                            value={exportFormFields.email_template_ids}
                                            onChange={(list) => {
                                              let event = {
                                                target: {
                                                  name: "email_template_ids",
                                                  value: list
                                                }
                                              }
                                              this.onChangeHandler(event)
                                            }}
                                            name="email_template_ids"
                                          />
                                        </div> : null
                                    }
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group row border-bottom">
                                    <label className="col-md-10">Email Data Config</label>
                                    <div className="col-md-2">
                                      <div className="material-switch p-2">
                                        <input id="email_data_config_include"
                                          name="email_data_config"
                                          type="checkbox"
                                          checked={exportFormFields.email_data_config}
                                          onChange={this.onChangeHandler}
                                        />
                                        <label htmlFor="email_data_config_include" className="secondary_bg"></label>
                                      </div>
                                    </div>
                                    {
                                      (exportFormFields.email_data_config) ?
                                        <div className="col-12">
                                          <Select
                                            isMulti={true}
                                            options={formFieldOptions.email_data_config}
                                            value={exportFormFields.email_data_config_ids}
                                            onChange={(list) => {
                                              let event = {
                                                target: {
                                                  name: "email_data_config_ids",
                                                  value: list
                                                }
                                              }
                                              this.onChangeHandler(event)
                                            }}
                                            name="email_data_config_ids"
                                          />
                                        </div> : null
                                    }
                                  </div>
                                </div>
                              </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body hide">
                {
                  (checkIsSystemUser()) ? <div className="row">
                    <div className="col-6">
                      <div className="" style={{'margin-top':'4.5rem'}}>
                        <div className="form-group row ">
                          <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4"> Choose Organisation</label>
                          <div className="col-lg-9 col-md-9 col-sm-8">
                            <div className="form-group">
                              <div className="input-group mb-3">
                                <select className="form-control" name="organization_id" onChange={e => this.onChangeHandler(e)}>
                                  <option value=""></option>
                                  {
                                    this.state.organization.options.map((arr, i) => {
                                      let organizationName = arr.organization_name;
                                        if(organizationName.length>80){
                                          organizationName = organizationName.substring(0,30)+"...";
                                        }
                                      return <option key={i} value={arr.id}>{organizationName}</option>
                                    })
                                  }
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : null
                }
                <div className="row">
                  <div className="col-6">
                    <div className="mt-3">
                      {checkIsSystemUser() ? <div className="form-group">
                        <h6 className="">Export Dataset Includes</h6>
                      </div> : <div className="mt-5">
                        <div className="form-group">
                          <h6 className="">Export Dataset Includes</h6>
                        </div>
                        
                      </div>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Base Data <br />[ user, profile, layout, organization and others information]</label>
                      <div className="col-lg-9 col-md-9 col-sm-8">
                        <div className="material-switch p-2">
                          <input id="base_include"
                            name="base"
                            type="checkbox"
                            checked={exportFormFields.base}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="base_include" className="secondary_bg"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Windows Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="window_include"
                            name="window"
                            type="checkbox"
                            checked={exportFormFields.window}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="window_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.window) ? <div className="col-lg-8 col-md-8 col-sm-7">
                          <Select
                            isMulti={true}
                            options={formFieldOptions.window}
                            value={exportFormFields.window_ids}
                            onChange={(list) => {
                              let event = {
                                target: {
                                  name: "window_ids",
                                  value: list
                                }
                              }
                              this.onChangeHandler(event)
                            }}
                            name="window_ids"
                          />
                        </div> : null
                      }

                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Api Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="api_include"
                            name="api"
                            type="checkbox"
                            checked={exportFormFields.api}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="api_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.api) ? <div className="col-lg-8 col-md-8 col-sm-7">
                          <Select
                            isMulti={true}
                            options={formFieldOptions.api}
                            value={exportFormFields.api_ids}
                            onChange={(list) => {
                              let event = {
                                target: {
                                  name: "api_ids",
                                  value: list
                                }
                              }
                              this.onChangeHandler(event)
                            }}
                            name="api_ids"
                          />
                        </div> : null
                      }

                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Steps Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="step_include"
                            name="step"
                            type="checkbox"
                            checked={exportFormFields.step}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="step_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.step) ? <div className="col-lg-8 col-md-8 col-sm-7">
                          {/* <Inputs  fieldName="api_name" formData={JSON.stringify(apiList)} changed={(e)=>console.log("api picklist")}/>  */}
                          <Select
                            isMulti={true}
                            options={formFieldOptions.step}
                            value={exportFormFields.step_ids}
                            onChange={(list) => {
                              let event = {
                                target: {
                                  name: "step_ids",
                                  value: list
                                }
                              }
                              this.onChangeHandler(event)
                            }}
                            name="api_ids"
                          />
                        </div> : null
                      }

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Calculation Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="calculation_include"
                            name="calculation"
                            type="checkbox"
                            checked={exportFormFields.calculation}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="calculation_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {(exportFormFields.calculation) ?
                        <div className="col-lg-8 col-md-8 col-sm-7">
                          <Select
                            isMulti={true}
                            options={formFieldOptions.calculation}
                            value={exportFormFields.calculation_ids}
                            onChange={(list) => {
                              let event = {
                                target: {
                                  name: "calculation_ids",
                                  value: list
                                }
                              }
                              this.onChangeHandler(event)
                            }}
                            name="api_ids"
                          />
                        </div> : null
                      }
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-lg-3 col-md-3 col-sm-4">Automation Data</label>
                  <div className="col-lg-1 col-md-1 col-sm-1">
                    <div className="material-switch p-2">
                      <input id="automation_include"
                        name="automation"
                        type="checkbox"
                        checked={exportFormFields.automation}
                        onChange={this.onChangeHandler}
                      />
                      <label htmlFor="automation_include" className="secondary_bg"></label>
                    </div>
                  </div>
                  {(exportFormFields.automation) ?
                    <div className="col-lg-8 col-md-8 col-sm-7">
                      <Select
                        isMulti={true}
                        options={formFieldOptions.automation}
                        value={exportFormFields.automation_ids}
                        onChange={(list) => {
                          let event = {
                            target: {
                              name: "automation_ids",
                              value: list
                            }
                          }
                          this.onChangeHandler(event)
                        }}
                        name="api_ids"
                      />
                    </div> : null
                  }
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">PDF Template Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="pdf_include"
                            name="pdf_template"
                            type="checkbox"
                            checked={exportFormFields.pdf_template}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="pdf_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.pdf_template) ?
                          <div className="col-lg-8 col-md-8 col-sm-7">
                            <Select
                              isMulti={true}
                              options={formFieldOptions.pdf}
                              value={exportFormFields.pdf_template_ids}
                              onChange={(list) => {
                                let event = {
                                  target: {
                                    name: "pdf_template_ids",
                                    value: list
                                  }
                                }
                                this.onChangeHandler(event)
                              }}
                              name="pdf_template_ids"
                            />
                          </div> : null

                      }

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Excel Template Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="excel_include"
                            name="excel_template"
                            type="checkbox"
                            checked={exportFormFields.excel_template}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="excel_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.excel_template) ?
                          <div className="col-lg-8 col-md-8 col-sm-7">
                            <Select
                              isMulti={true}
                              options={formFieldOptions.excel}
                              value={exportFormFields.excel_template_ids}
                              onChange={(list) => {
                                let event = {
                                  target: {
                                    name: "excel_template_ids",
                                    value: list
                                  }
                                }
                                this.onChangeHandler(event)
                              }}
                              name="excel_template_ids"
                            />
                          </div> : null
                      }

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Email Template Data</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="email_include"
                            name="email_template"
                            type="checkbox"
                            checked={exportFormFields.email_template}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="email_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.email_template) ?
                          <div className="col-lg-8 col-md-8 col-sm-7">
                            <Select
                              isMulti={true}
                              options={formFieldOptions.email}
                              value={exportFormFields.email_template_ids}
                              onChange={(list) => {
                                let event = {
                                  target: {
                                    name: "email_template_ids",
                                    value: list
                                  }
                                }
                                this.onChangeHandler(event)
                              }}
                              name="email_template_ids"
                            />
                          </div> : null
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-group row">
                      <label className="col-lg-3 col-md-3 col-sm-4">Email Data Config</label>
                      <div className="col-lg-1 col-md-1 col-sm-1">
                        <div className="material-switch p-2">
                          <input id="email_data_config_include"
                            name="email_data_config"
                            type="checkbox"
                            checked={exportFormFields.email_data_config}
                            onChange={this.onChangeHandler}
                          />
                          <label htmlFor="email_data_config_include" className="secondary_bg"></label>
                        </div>
                      </div>
                      {
                        (exportFormFields.email_data_config) ?
                          <div className="col-lg-8 col-md-8 col-sm-7">
                            <Select
                              isMulti={true}
                              options={formFieldOptions.email_data_config}
                              value={exportFormFields.email_data_config_ids}
                              onChange={(list) => {
                                let event = {
                                  target: {
                                    name: "email_data_config_ids",
                                    value: list
                                  }
                                }
                                this.onChangeHandler(event)
                              }}
                              name="email_data_config_ids"
                            />
                          </div> : null
                      }
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Wrp>

    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader: () => dispatch(actions.loader()),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg))
  };
}
export default
  connect(
    null,
    mapDispatchToProps
  )(withRouter(ExportContainerV2));



